import { Company } from '../types/company';
import { Deal } from '../types/deal';

/**
 * VICS 필수값 점검 — 1313 투자기업 등록 · 1316 재무제표 · 1319 투자유형 · 1320 투자거래.
 *
 * ⚠️ 필수값은 **추정**이다(factsheet VICS 연동 가이드에서 역으로 짚음). 정본은 VICS 실화면.
 *
 * 메뉴 이름은 `docs/02-design/050-vics-integration.md` 1-3 절로 고쳤다(2026-10-27).
 * 1319 는 투자유형(재원 × 유형 · 투자계약번호 생성), **1320 은 투자와 회수 둘 다**다 —
 * 전에는 1319 「투자정보」 · 1320 「회수정보」로 잘못 적혀 있었다.
 */
export type VicsMenu = '1313' | '1316' | '1319' | '1320';
export const VICS_MENU_LABEL: Record<VicsMenu, string> = {
  '1313': '투자기업 등록', '1316': '재무제표 관리', '1319': '투자유형 관리', '1320': '투자거래 관리',
};

/** 1313 — 투자처에서 비어 있는 칸 */
export function missingProfile(c: Company | undefined): string[] {
  if (!c) return ['기업정보 전체'];
  const m: string[] = [];
  if (!c.bizNo) m.push('사업자번호');
  if (!c.corpNo) m.push('법인번호');
  if (!c.foundedOn) m.push('설립일');
  if (!c.address) m.push('본사 주소');
  if (!c.industryCode) m.push('업종코드');
  if (c.ventureCert === null || c.ventureCert === undefined) m.push('벤처인증');
  if (!c.fiscalMonth) m.push('결산월');
  if (!c.contactName) m.push('담당자');
  if (!c.contactEmail) m.push('담당자 이메일');
  return m;
}

/** 1316 — 직전 사업연도 재무제표(연간 실적)가 있나. 상반기만 있으면 찬 것이 아니다(#77). financials 는 그 회사의 재무 줄들 */
export function missingFinancial(financials: { fiscalYear: number; isForecast?: boolean; fiscalPeriod?: string }[], year: number): string[] {
  return financials.some((f) => f.fiscalYear === year && !f.isForecast && (f.fiscalPeriod ?? 'FY') === 'FY') ? [] : [`${year} 재무제표`];
}

/**
 * 1320 투자거래(투자 · 회수) — 거래 줄에서 비어 있는 칸. 증권 종류는 1319 투자유형 쪽이다.
 * whole=false 면 건의 주식수가 이 원장 줄 몫이 아니다(여러 번 나눠 투자 · 부분 회수) — 지어 넣지 않고 빈칸으로 본다
 */
export function missingTerms(d: Deal | undefined, isExit: boolean, whole = true): string[] {
  const m: string[] = [];
  if (!whole) m.push('이 줄의 주식수(여러 번 나눈 거래)');
  else if (!d || d.shares == null) m.push('주식수');
  if (!d || d.pricePerShare == null) m.push('주당 가격');
  if (isExit && (!d || !d.exitMethod)) m.push('회수 방식');
  return m;
}
